import React, { Component } from 'react';
import MediaQuery from 'react-responsive';

import NavBar from '../navBar/NavBar';
import LandingSection from './landing/Landing';
import AwardsSection from './awards/AwardsSection';
import PublicationsListSection from './publicationsList/PublicationsList';
import Footer from '../footer/Footer';
import './Publications.css';
import ScrollToTopOnMount from '../ScrollToTop';

import { trackPage } from '../helpers/AnalyticsManager';

class Publications extends Component {
  constructor() {
    super();

    trackPage('Publications');
  }

  render() {
    return (
      <div className="Publications">
        <ScrollToTopOnMount />
        <NavBar darkMode />
        <LandingSection />
        <MediaQuery query="(max-width: 425px)">
          {isMobile => <AwardsSection isMobile={isMobile} />}
        </MediaQuery>
        <PublicationsListSection />
        <Footer target="industry" language="english" />
      </div>
    );
  }
}

export default Publications;
